import { Button } from "antd";

interface FilterFooterProps {
  onClose?: () => void;
  onClear?: () => void;
  onApply?: () => void;
  onDelete?: () => void;
  isApplyDisabled?: boolean;
  isClearDisabled?: boolean;
  isDropdown?: boolean;
  useAlternativeLayout?: boolean;
}

const FilterFooter = ({
  onClose,
  onClear,
  onApply,
  onDelete,
  isApplyDisabled = false,
  isClearDisabled = false,
  isDropdown,
  useAlternativeLayout = false,
}: FilterFooterProps) => {
  if (useAlternativeLayout) {
    return (
      <div
        className={`flex justify-between border-t pt-2 mt-auto ${
          isDropdown ? "" : "mt-2 mb-3"
        }`}
      >
        <Button
          size="small"
          onClick={onClear}
          className="text-[#2B4752]"
          disabled={isClearDisabled}
        >
          Clear
        </Button>
        <Button
          size="small"
          className={
            isApplyDisabled
              ? ""
              : "bg-[#D2EFF9] border border-[#06709B] text-[#06709B]"
          }
          onClick={onApply}
          disabled={isApplyDisabled}
        >
          Apply
        </Button>
      </div>
    );
  }

  return (
    <div
      className={`flex justify-between border-t pt-2 mt-auto ${
        isDropdown ? "" : "mt-2 mb-3"
      }`}
    >
      {isDropdown ? (
        <Button
          type="text"
          size="small"
          onClick={onDelete}
          className="text-[#064C68]"
        >
          Delete
        </Button>
      ) : (
        <Button
          type="text"
          size="small"
          onClick={onClose}
          className="text-[#064C68]"
        >
          Close
        </Button>
      )}

      <div className="flex gap-2">
        <Button
          size="small"
          onClick={onClear}
          className="text-[#2B4752]"
          disabled={isClearDisabled}
        >
          Clear
        </Button>
        <Button
          size="small"
          className={
            isApplyDisabled
              ? ""
              : "bg-[#D2EFF9] border border-[#06709B] text-[#06709B]"
          }
          onClick={onApply}
          disabled={isApplyDisabled}
        >
          Ok
        </Button>
      </div>
    </div>
  );
};

export default FilterFooter;
